import { render, staticRenderFns } from "./ProjectSeting.vue?vue&type=template&id=7d1fc980&scoped=true"
import script from "./ProjectSeting.vue?vue&type=script&lang=js"
export * from "./ProjectSeting.vue?vue&type=script&lang=js"
import style0 from "./ProjectSeting.vue?vue&type=style&index=0&id=7d1fc980&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fc980",
  null
  
)

export default component.exports